export enum StorefrontCollectionLayout {
  ROW_XL = 'ROW_XL',
  ROW_L = 'ROW_L',
  ROW_M = 'ROW_M',
}
